(function () {
  const phoneInputs = document.querySelectorAll(`input[name="phone"]`);

  if (phoneInputs.length === 0) {
    return;
  }

  Array
    .from(phoneInputs)
    .forEach((input) => {
      $(`#${input.id}`).mask(`+7 (999) 999-99-99`);
    });
})();
